import { Button, Card, ConfigProvider, Image, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import LcheckEmail from "../../../../assets/images/check-email-econnect-2025.png";
import successText from "../../../../assets/images/success-econnect-2025.png";
import ticketNo from "../../../../assets/images/TicketNo.png";
import { UserEventService } from "../../../../api/user.service";
import { useId24 } from "../../../../drivers/id24/Id24Provider";
import { useNavigate, useParams } from "react-router-dom";
import Meta from "antd/es/card/Meta";
import Title from "antd/es/typography/Title";
import { loadAppConfig } from "../../../../configs/app-config";
import LogoAi from "../../../../assets/images/message_icon.png";
import { ArrowLeftOutlined } from "@ant-design/icons";

export const EconnectStepFour: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const navigate = useNavigate();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { agendaid, ticketid } = useParams<{
    agendaid: string;
    ticketid: string;
  }>();

  const [loading, setLoading] = useState<boolean>(true);
  const [userData, setUserDate] = useState<{
    numberId: string;
    dataSource: { ticketNumber: string };
  }>({
    numberId: "",
    dataSource: { ticketNumber: "" },
  });

  useEffect(() => {
    if (loading) {
      featchData();
    }
  }, [loading]);

  const featchData = async () => {
    try {
      if (agendaid && ticketid) {
        const user = await UserEventService(apiBaseUrl).getByEventAndTicket(
          agendaid,
          ticketid
        );
        setUserDate(user);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  return loading ? (
    <Card className="w-full">
      <Skeleton loading={loading} avatar active>
        <Meta title="Card Title" description="Card description" />
      </Skeleton>
    </Card>
  ) : (
    <Card className=" my-4">
      <div className="w-[353px] h-[653.18px] left-[25px] rounded-[10px] pt-[32px] pr-[26px] pb-[32px] pl-[26px] gap-[32px] text-center text-[#1C0A64]">
        <div className=" flex justify-center">
          <Image
            src={LogoAi}
            preview={false}  width={100}
          />
        </div>
        <br />
        <br />
        <div className=" font-bold text-[40px]">Registration Completed</div>
        <div className=" font-bold text-[16px]">
          Thank you for registering!
        </div>
        <div className=" font-light text-[16px] leading-[24px]">
          We have received your information and sent a confirmation email to the
          address you provided.
        </div>
           <div className=" font-light text-[16px] leading-[24px]">
      The email includes the event agenda and
          important details for your visit.
        </div>
        <br />
        <br />
        <ConfigProvider theme={{ token: { colorPrimary: "#160C65" } }}>
          <Button
            type="primary"
            ghost
            color="magenta"
            className="w-[301px] h-[58px] rounded-[5px] border-2 px-[45px] py-[13px] gap-8 "
            onClick={() =>
              navigate(`/activity-agenda/activity-step/${agendaid}`)
            }
          >
            <h2 className="font-manrope font-bold text-[20px] leading-[32px] tracking-[0px] text-center ">
              <ArrowLeftOutlined /> Back
            </h2>
          </Button>
        </ConfigProvider>
      </div>
    </Card>
  );
};
